module.exports = __webpack_public_path__ + "045022d31a7aafd8a543b1dae2c0bc98.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/smarty.png
// module id = 510
// module chunks = 0